export const localeList = {
    af: "Afrikaans", // Afrikaans
    ar: "العربية", // Arabic
    bd: "Belgisch-Nederlands", // Belgian Dutch
    bf: "Français de Belgique", // Belgian French
    bg: "български", // Bulgarian
    bn: "বাংলা",
    bp: "Português (Brasil)", //Portuguese (Brazil)
    cc: "Cebuano (Cebu)",
    cd: "Cebuano (Davao)",
    ck: "傳統中文", // Traditional Chinese (Hong Kong)
    cs: "Čeština", // Czech
    ct: "繁體中文", // Traditional Chinese (Taiwan)
    da: "Dansk", // Danish
    de: "Deutsch", // German
    el: "ελληνικα", // Greek
    en: "English", // English
    ea: "English-Australia", // English-Australia
    es: "Español", // Spanish (EU)
    et: "Eesti", //
    fc: "Français canadien", // French Canadian
    fi: "Suomi", // Finnish
    fr: "Français", // French (EU)
    gs: "Schweizerdeutsch", // Swiss German
    gu: "Gujarati",
    he: "עברית", // Hebrew
    hi: "हिंदी", // Hindi
    hg: "Hiligaynon", // Hindi
    hr: "Hrvatski", // Croatian
    hu: "Magyar", // Hungarian
    hy: "հայերեն", // Armenian
    it: "Italiano", // Italian
    iw: "Svizzero Italiano", // Swiss Italian
    ja: "日本語", // Japanese
    ka: "ქართული", // Georgian
    ko: "한국어", // Korean
    kn: "ಕನ್ನಡ", // Kannada
    lp: "Español latinoamericano", // Spanish LATAM
    lt: "Lietuviškai", // Lithuanian
    lv: "Latviski", // Latvia
    ml: "മലയാളം", //Malayalam
    mr: "मराठी", // Marathi
    ms: "Melayu",
    nl: "Nederlands", // Dutch
    no: "Norsk", // Norwegian
    ns: "Sesotho sa Leboa", // Northern Sotho
    pa: "ਪੰਜਾਬੀ", // Punjabi
    pl: "Polski", // Polish
    pt: "Português", // Portuguese
    ro: "Română", // Romanian
    ru: "Русский", // Russian
    sf: "Français de Suisse", // Swiss French
    sk: "Slovensky", // Slovak
    sl: "Slovenščina", // Slovenian
    sp: "Español-EE.UU", // US Spanish
    sr: "Srpski", // Serbian
    st: "Sesotho sa Borwa", // Southern Sotho
    sv: "Svenska", // Swedish
    sy: "Српски (ћирилица)", // Serbian (Cyrillic)
    ta: "தமிழ்", //Tamil
    te: "తెలుగు", //Telugu,
    tl: "Tagalog", // Tagalog
    to: "Tongan",
    tr: "Türkçe", // Turkish
    th: "ไทย",
    uk: "українська",
    vi: "Tiếng Việt", // Vietnamese
    xh: "isiXhosa", // Xhosa
    ze: "English-South Africa",
    zh: "简体中文", // Simplified Chinese
    zu: "Zulu", // Zulu
}